<template lang="pug">
  div.detail-layout
    div.combo-table
      div.combo-table--head
        div.combo-cell 藥名
        div.combo-cell 取藥狀況
        div.combo-cell 取藥事件
      div.combo-row(v-for="med in comboMedsEvent")
        div.combo-cell {{ med.child_medication.generic_name }} 
        div.combo-cell {{med.fetched | fetchedZh }} 
        div.combo-cell
          span(v-if="med.event") {{med.event.employee_name}} 於 {{med.event.record_time | timeFromNow}}取 {{ -(med.event.number1) }} 單位藥量

</template>

<script>
import moment from 'moment';

export default {
  name: 'ScheduleDetail',
  props: [
    'rowData',
  ],
  data() {
    return {
      comboMedsEvent: null,
    };
  },
  created() {
    this.checkMedUsage();
  },
  methods: {
    checkMedUsage() {
      console.log('check medication usage');
      const events = {};
      this.rowData.fetch_event.forEach((event) => {
        events[event.medication.id] = event;
      });

      const comboMeds = this.rowData.combo_relationship;
      comboMeds.forEach((combo) => {
        if (events[combo.child_medication.id]) {
          combo.event = events[combo.child_medication.id];
          combo.fetched = true;
        } else {
          combo.event = null;
          combo.fetched = false;
        }
      });

      this.comboMedsEvent = comboMeds;
    },
  },
  filters: {
    timeFromNow(val) {
      moment.locale('zh-tw');
      return moment(val).fromNow();
    },
    fetchedZh(val) {
      if (val) return '已取藥';
      return '未取藥';
    },
  },
};
</script>

<style lang="sass">
.detail-layout
  background: white
.combo-table
  width: 100%
  display: table
  .combo-table--head
    display: table-row
    background: cadetblue;
    color: white
    > div
      display: table-cell
      border: 1px solid rgba(0, 0, 0, 0.2);
  .combo-row
    display: table-row
  .combo-cell
    display: table-cell
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 2px 10px;
    font-size: 14px;


</style>



// WEBPACK FOOTER //
// ScheduleDetail.vue?f12e989e